import { Navigate, useLocation } from "react-router-dom";
import { LoadingState } from "../components/ui";
import { useAuth } from "./AuthProvider";
import type { ReactNode } from "react";

/** Wraps every route that needs a signed-in member of this tenant; sends the signed-out to /login with a way back. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();
  if (status === "loading") return <LoadingState label="Signing in…" />;
  if (status === "signed-out") return <Navigate to="/login" replace state={{ from: location }} />;
  return <>{children}</>;
}
